import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="relative rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20dark%20background%20with%20soft%20golden%20spotlight%20effect%2C%20abstract%20film%20reel%20elements%2C%20elegant%20theater%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20cinematic%20lighting&width=1280&height=400&seq=cta-cinema-bg&orientation=landscape"
            alt=""
            className="w-full h-[200px] md:h-[280px] object-cover object-center"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 to-background-950/50" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h2 className="text-lg md:text-2xl font-bold text-foreground-50 font-heading mb-3">
              准备好开始观影了吗？
            </h2>
            <p className="text-sm text-foreground-400 mb-6 max-w-md">
              海量高清影视资源，无需注册，免费观看
            </p>
            <Link
              to="/category/dianying"
              className="px-8 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即探索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}